<template>
<div>
  <FuelStore ref="fuelStore" />

  <div>
    <h3>Fuel Summary Report</h3>

    <GenericDatePeriodSelector storeName="fuelStore" />
    <GenericDaysSelector storeName="fuelStore" />
    
    <!-- Toggle switch for showing only totals vs all daily data -->
    <div style="margin: 20px 0; padding: 10px; background-color: #f5f5f5; border-radius: 5px;">
      <label style="display: flex; align-items: center; cursor: pointer;">
        <input 
          type="checkbox" 
          v-model="showOnlyTotal"
          style="margin-right: 10px; transform: scale(1.2);"
        />
        <span style="font-weight: bold;">Show Monthly Total Only (for printing)</span>
      </label>
      <small style="color: #666; margin-left: 30px;">
        Toggle this on to show only monthly totals for quick reports
      </small>
    </div>

    <h3>RCGB</h3>
    <PayAtPumpSummary location="RCGB" />
    <h3>RMGB</h3>
    <PayAtPumpSummary location="RMGB" />
    <h3>WGB</h3>
    <PayAtPumpSummary location="WGB" />
  </div>


</div>
</template>

<script>
import FuelStore from './Stores/FuelStore.vue'
import PayAtPumpSummary from './Components/PayAtPumpSummary.vue'
import formatDataMixin from '@/mixins/formatDataMixin.js'

export default {
  name: 'FuelSummaryReport',
  mixins : [formatDataMixin],
  components:{PayAtPumpSummary,         FuelStore},
  data() {
    return {
      showOnlyTotal: false
    }
  },
  provide() {
    return {
      payAtPumpPage: this,
      page: this,
    }
  },
  computed:{
    // fuelStore(){ return this.$refs.fuelStore},
    timestamps(){ return this.$refs.fuelStore.timestamps},
  },

}
</script>

<style lang="scss" scoped>

</style>